import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const EFFICIENCY_SCORECARD_FILTERS = REPORTS_DEFAULT_FILTERS

export const EFFICIENCY_SCORECARD_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'currencyPerHour' | 'percent' | 'currency'
}> = [
  {
    id: 'efficiency-score',
    title: 'Efficiency Score',
    footer: 'Total Production divided by available chair time',
    format: 'currencyPerHour',
  },
  {
    id: 'production-per-hour',
    title: 'Production per Hour',
    footer: 'Production divided by chair hours used',
    format: 'currencyPerHour',
  },
  {
    id: 'chair-utilization',
    title: 'Chair Utilization',
    footer: 'Chair hour used divided by available chair hour',
    format: 'percent',
  },
  {
    id: 'total-production',
    title: 'Total Production',
    footer: 'Sum of production amount',
    format: 'currency',
  },
]

export type ProviderFinancialRow = {
  id: string
  provider: string
  production: string
  productionPerHour: string
  efficiencyScore: string
  chairUtilization: string
}
